import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  // WORKING CONFIG — REPLACE service_kt8vzli WITH YOUR NEW DEFAULT SERVICE ID
  const EMAILJS_PUBLIC_KEY = "gR42kMLn6SLj_Xrmx";
  const EMAILJS_SERVICE_ID = "service_kt8vzli";  // ← YOUR NEW DEFAULT SERVICE ID
  const EMAILJS_TEMPLATE_ID = "template_9lqtcc5";

  useEffect(() => {
    if (typeof window === "undefined" || window.emailjs) return;

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js";
    script.async = true;
    script.onload = () => {
      window.emailjs.init(EMAILJS_PUBLIC_KEY);
      console.log("EmailJS Ready!");
    };
    document.body.appendChild(script);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const result = await window.emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.mobile,
          message: formData.message || "No message provided",
          to_email: "indiaadvertising05@gmail.com",  // ← Ensures delivery
        }
      );

      console.log("Email Sent:", result);  // Check console for confirmation
      setStatus("success");
      setFormData({ name: "", mobile: "", email: "", message: "" });
    } catch (err) {
      console.error("EmailJS Error Details:", err.status, err.text);
      setStatus("error");
    } finally {
      setTimeout(() => setStatus(""), 5000);
    }
  };

  return (
    <section id="contact" className="py-12 sm:py-20 bg-navy-50">
      <div className="px-4 mx-auto max-w-7xl">
        <motion.h2
          className="mb-8 text-3xl font-bold text-center sm:text-5xl sm:mb-12 text-navy-800"
          initial={{ y: -50 }}
          whileInView={{ y: 0 }}
          viewport={{ once: true }}
        >
          Contact Us
        </motion.h2>

        <motion.div
          className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          {/* Contact Details */}
          <div className="space-y-4 text-navy-700">
            <h3 className="text-xl font-bold sm:text-2xl">Details</h3>
            <p className="text-sm sm:text-base">
              <strong>Address:</strong> Plot No. H-27, First Floor, Sector-9 Gautam Buddha Nagar, Noida, UP-201301
            </p>
            <p className="text-sm sm:text-base">
              <strong>Phone:</strong>{" "}
              <a href="tel:+919899572539" className="text-blue-600 transition-colors hover:text-blue-800 hover:underline">
                +91 9899572539
              </a>
              <span> , </span>
              <a href="tel:0120-4486192" className="text-blue-600 transition-colors hover:text-blue-800 hover:underline">
                0120-4486192
              </a>
            </p>
            <p className="text-sm sm:text-base">
              <strong>Email:</strong>{" "}
              <a href="mailto:indiaadvertising05@gmail.com" className="text-blue-600 transition-colors hover:text-blue-800 hover:underline">
                indiaadvertising05@gmail.com
              </a>
            </p>
            <p className="text-sm sm:text-base">
              <strong>Website:</strong>{" "}
              <a href="https://www.indiadvertising.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 transition-colors hover:text-blue-800 hover:underline">
                www.indiadvertising.com
              </a>
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 border rounded sm:p-4 border-navy-300 focus:border-yellow-500 focus:outline-none"
              required
            />
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile No."
              value={formData.mobile}
              onChange={handleChange}
              className="w-full p-3 border rounded sm:p-4 border-navy-300 focus:border-yellow-500 focus:outline-none"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 border rounded sm:p-4 border-navy-300 focus:border-yellow-500 focus:outline-none"
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              className="w-full p-3 border rounded sm:p-4 border-navy-300 focus:border-yellow-500 focus:outline-none"
              required
            />
            <motion.button
              type="submit"
              disabled={status === "sending"}
              className={`w-full py-3 text-sm font-bold rounded text-navy-800 sm:py-4 sm:text-base neon-glow transition-all duration-300 ${
                status === "sending" ? "bg-gray-400 cursor-not-allowed" : "bg-yellow-500 hover:bg-yellow-600 active:scale-95"
              }`}
              whileHover={status !== "sending" ? { scale: 1.02 } : {}}
              whileTap={status !== "sending" ? { scale: 0.98 } : {}}
              aria-busy={status === "sending"}
            >
              {status === "sending" ? "Sending…" : "Send Message"}
            </motion.button>

            {/* Feedback Toast */}
            {status === "success" && (
              <motion.div 
                className="p-4 mt-2 text-center text-green-600 border-l-4 border-green-600 rounded bg-green-50"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
              >
                ✓ Message sent successfully! We'll be in touch soon.
              </motion.div>
            )}
            {status === "error" && (
              <motion.div 
                className="p-4 mt-2 text-center text-red-600 border-l-4 border-red-600 rounded bg-red-50"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
              >
                ✗ Failed to send. Please try again or call us directly.
              </motion.div>
            )}
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;